import CertificateOfStudiesRepository from '../../domain/repositories/CertificateOfStudiesRepository';
import CertificateOfStudiesDataStore from '../datastores/CertificateOfStudiesDataStore';
import CertificateOfStudiesDataStoreFactory from '../factories/CertificateOfStudiesDataStoreFactory';

export default class CertificateOfStudiesDataRepository
  implements CertificateOfStudiesRepository
{
  register(
    procedureId: number,
    period: string,
    periodDesc: string,
    program: string,
    weightedAverage: string,
    hasDebts: boolean,
    CodCarrera: string
  ) {
    const certificateOfStudiesDataStore: CertificateOfStudiesDataStore =
      CertificateOfStudiesDataStoreFactory.create();
    return certificateOfStudiesDataStore.register(
      procedureId,
      period,
      periodDesc,
      program,
      weightedAverage,
      hasDebts,
      CodCarrera
    );
  }

  activatePayment(procedureId: number, requestId: number, career: string) {
    const certificateOfStudiesDataStore: CertificateOfStudiesDataStore =
      CertificateOfStudiesDataStoreFactory.create();
    return certificateOfStudiesDataStore.activatePayment(
      procedureId,
      requestId,
      career
    );
  }

  downloadFile(key: string) {
    const certificateOfStudiesDataStore: CertificateOfStudiesDataStore =
      CertificateOfStudiesDataStoreFactory.create();
    return certificateOfStudiesDataStore.downloadFile(key);
  }

  paymentsStatusVerification(requestId: number) {
    const certificateOfStudiesDataStore: CertificateOfStudiesDataStore =
      CertificateOfStudiesDataStoreFactory.create();
    return certificateOfStudiesDataStore.paymentsStatusVerification(requestId);
  }
}
